module.exports = __webpack_public_path__ + "static/media/manufacturing-microone-01 4.36882941.png";